import Client from "./client";

// `hostKey` names what the thread hangs off ("bug", "ticket") - see
// api/lib/threads.js's THREAD_HOSTS, which is the only place that list
// lives. Both calls below are host-agnostic on purpose: a new kind of
// threadable record needs nothing added here.

export const GetThread = ({hostKey, entityId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/threads/${hostKey}/${entityId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.thread);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// `visibility` is "PUBLIC" (part of the conversation with whoever is outside
// the project) or "INTERNAL" (a note between members, never sent onward).
export const PostThreadMessage = ({hostKey, entityId, body, visibility, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/threads/${hostKey}/${entityId}`, {body, visibility}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.message);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}
